<template>
  <router-view />
  <NiceToast />
  <NiceNotifications />
  <NiceSvgs />
</template>

<script setup></script>
